import { KeyboardEvent } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

export interface UseTryIntentProps {
    intentType: "button" | "form" | "demo" | "buy";
    containerId?: string;
    productKey?: string;
    edition?: string;
    onAnalyticsEventFired?: () => void;
}
export function useTryIntent(props: UseTryIntentProps) {
    const {
        intentType,
        containerId,
        productKey,
        edition,
        onAnalyticsEventFired
    } = props;

    const { createAnalyticsEvent } = useAnalyticsEvents();

    const onClick = () => {
        createAnalyticsEvent({
            eventType: "track",
            action: "interacted",
            actionSubject: "tryIntentComponent",
            containerId: containerId,
            actionSubjectId: intentType,
            attributes: {
                productKey: productKey,
                edition: edition
            }
        }).fire();
        onAnalyticsEventFired && onAnalyticsEventFired();
    };
    const onKeyDown = (e: KeyboardEvent) => {
        if (e.code !== "Tab" && e.code !== "Enter" && e.code !== "Space") {
            createAnalyticsEvent({
                eventType: "track",
                action: "interacted",
                actionSubject: "tryIntentComponent",
                containerId: containerId,
                actionSubjectId: intentType,
                attributes: {
                    productKey: productKey,
                    edition: edition
                }
            }).fire();
            onAnalyticsEventFired && onAnalyticsEventFired();
        }
    };

    return {
        onClick,
        onKeyDown
    };
}
